import axiosClient from './axiosClient';

/**
 * ShopeeFood không có API sản phẩm/hoa hồng như Shopee — chỉ tạo link gắn tracking
 * từ link quán/món người dùng dán vào (backend gắn utm_content = subId).
 */
const shopeefoodApi = {
    getLink: (link, source) =>
        axiosClient.post('shopeefood/get-link', { link, ...(source && { source }) }),
};

export default shopeefoodApi;
